var map = {
	"./Access Manager.svg": "e919",
	"./Africanbar.svg": "e24a",
	"./Goldy-snack.svg": "a30d",
	"./Goldy.svg": "7a1f",
	"./Icon EDV.svg": "f9cd",
	"./InfoIcon.svg": "db19",
	"./Logo Drawer.svg": "1faf",
	"./Logo contact.svg": "b7e1",
	"./Logo.svg": "1a86",
	"./MOS Blue.svg": "d923",
	"./MOS Green.svg": "a0a8",
	"./MOS Red.svg": "1924",
	"./Page not Found.svg": "29c3",
	"./Project Status.svg": "3ea91",
	"./Recon.svg": "5d03",
	"./architecture.svg": "4d642",
	"./black-red.svg": "191a",
	"./callAction.svg": "c465",
	"./cardPattern.svg": "ba4d",
	"./dark/Africanbar.svg": "05be",
	"./dark/Goldy-snack.svg": "fff7",
	"./dark/Goldy.svg": "6fe5",
	"./dark/Icon EDV.svg": "9c2e",
	"./dark/Logo Drawer.svg": "1c11",
	"./dark/Logo contact.svg": "15cc",
	"./dark/Logo.svg": "cbc4",
	"./dark/Page not Found.svg": "6dbe",
	"./dark/black-red.svg": "2d51",
	"./dark/cardPattern.svg": "f884",
	"./dark/drawer_background_dark.svg": "0045",
	"./dark/ecosystem/Background.svg": "0132",
	"./dark/ecosystem/Design.svg": "bbf8",
	"./dark/ecosystem/Features.svg": "7a33",
	"./dark/home/Alldevice.png": "b433",
	"./dark/home/AlldeviceMobile.png": "2df1",
	"./dark/home/Auth.svg": "a30c",
	"./dark/home/Background.png": "3fe4",
	"./dark/home/Desktop.png": "8d42",
	"./dark/home/Phone.png": "b0e7",
	"./dark/home/Pit.svg": "70a5",
	"./dark/home/Tablet.png": "aaa2",
	"./dark/home/Vector_BG.svg": "da5d",
	"./dark/home/WOR.svg": "8178",
	"./dark/home/architecture.svg": "25c4",
	"./dark/home/chip.svg": "a1e6",
	"./dark/home/codigo.svg": "5754",
	"./dark/home/computegoldy.svg": "f931",
	"./dark/home/data.svg": "1cd4",
	"./dark/home/dos.svg": "9193",
	"./dark/home/grafico.svg": "2260",
	"./dark/home/how works.svg": "2d26",
	"./dark/home/improvement.svg": "40ae",
	"./dark/home/mosDashboard.svg": "bb3a",
	"./dark/home/nube.svg": "771f",
	"./dark/home/process.svg": "1579",
	"./dark/home/reports.svg": "f158",
	"./dark/home/schedule.svg": "9d27",
	"./dark/modules/access manager/menu.svg": "d623",
	"./dark/modules/access manager/user.svg": "3319",
	"./dark/modules/access manager/users.svg": "0f9d",
	"./dark/modules/improvement funnel/dashboard.svg": "7759",
	"./dark/modules/improvement funnel/ideas.svg": "a88f",
	"./dark/modules/improvement funnel/innovation funnel.svg": "15b5",
	"./dark/modules/mining production/dashboard.svg": "6c7f",
	"./dark/modules/mining production/grade control.svg": "206a",
	"./dark/modules/mining production/report.svg": "4656",
	"./dark/modules/reconciliation/Data Entry.svg": "0a75",
	"./dark/modules/reconciliation/classifications.svg": "b460",
	"./dark/modules/reconciliation/summary.svg": "d91b",
	"./dark/otherModules/AFE.svg": "ab70",
	"./dark/otherModules/Action Tracker.svg": "5fc7",
	"./dark/otherModules/Group Roster.svg": "3ea9",
	"./dark/otherModules/Integrate Communication.svg": "9adc",
	"./dark/otherModules/Internal Travel.svg": "fa01",
	"./dark/otherModules/Library Document.svg": "e924",
	"./dark/otherModules/Mobile prestar.svg": "0c26",
	"./dark/otherModules/OPEX.svg": "9d63",
	"./dark/otherModules/Production Schedule.svg": "720e",
	"./dark/otherModules/Professional Development.svg": "af2a",
	"./dark/otherModules/R&R.svg": "4946",
	"./dark/otherModules/access manager.svg": "8098",
	"./dataDrive.svg": "8419",
	"./dataOrganization.svg": "1d09",
	"./dataProject.svg": "62aa",
	"./drawer_background.svg": "e17f",
	"./ecosystem/Background.svg": "a10e",
	"./ecosystem/Design.svg": "2128",
	"./ecosystem/Features.svg": "0607",
	"./goal.svg": "02b1",
	"./home/Alldevice.png": "d999",
	"./home/AlldeviceMobile.png": "018f",
	"./home/Auth.svg": "46e6",
	"./home/Background.png": "3bac",
	"./home/Desktop.png": "9c58",
	"./home/Phone.png": "367a",
	"./home/Pit.svg": "e17b",
	"./home/Tablet.png": "030f",
	"./home/Vector_BG.svg": "3aa4",
	"./home/WOR.svg": "2852",
	"./home/architecture.svg": "7609",
	"./home/chip.svg": "7c4d",
	"./home/codigo.svg": "5f14",
	"./home/computegoldy.svg": "1e22",
	"./home/data.svg": "28cf",
	"./home/dos.svg": "6ee7",
	"./home/grafico.svg": "090a",
	"./home/how works.svg": "97e6",
	"./home/improvement.svg": "d775",
	"./home/mosDashboard.svg": "f653",
	"./home/nube.svg": "8a75",
	"./home/process.svg": "b827",
	"./home/reports.svg": "7e4c",
	"./home/schedule.svg": "d995",
	"./meta.svg": "3d5a",
	"./modules/access manager/menu.svg": "512d",
	"./modules/access manager/nomenu.svg": "ae49",
	"./modules/access manager/user.svg": "1e55",
	"./modules/improvement funnel/dashboard.svg": "84f1",
	"./modules/improvement funnel/ideas.svg": "38b1",
	"./modules/improvement funnel/innovation funnel.svg": "72b8",
	"./modules/mining production/dashboard.svg": "afff",
	"./modules/mining production/grade control.svg": "c4f8",
	"./modules/mining production/report.svg": "b09f",
	"./modules/reconciliation/Data Entry.svg": "21c2",
	"./modules/reconciliation/Edit.svg": "a887",
	"./modules/reconciliation/SRK.svg": "c718",
	"./modules/reconciliation/classifications.svg": "274b",
	"./modules/reconciliation/summary.svg": "e8ae",
	"./otherModules/AFE.svg": "bf46",
	"./otherModules/Action Tracker.svg": "7c62",
	"./otherModules/Group Roster.svg": "1594",
	"./otherModules/Integrate Communication.svg": "44ac",
	"./otherModules/Internal Travel.svg": "4319",
	"./otherModules/Library Document.svg": "c499",
	"./otherModules/Mobile prestar.svg": "d061",
	"./otherModules/OPEX.svg": "9afe",
	"./otherModules/Production Schedule.svg": "d504",
	"./otherModules/Professional Development.svg": "caf8",
	"./otherModules/R&R.svg": "8928",
	"./otherModules/access manager.svg": "1cdd",
	"./poster.png": "14ae",
	"./trend.svg": "f00f",
	"./vid.mp4": "6758"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";